import React, { ChangeEvent, useState } from 'react'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import { setOfferForm, submitUpdateOffer } from './model'
import { useOffer } from './hooks'
import { Flex } from 'antd'
import { OfferLinkForm } from '../widgets/OfferLinkManagerForm/component'
import { OfferLink } from '../list/types'
import { initialOfferLink } from '../constants'

export const EditOffer: React.FC = () => {
  const [validated, setValidated] = useState(false)

  const { offer, error, loading } = useOffer()

  const [offerLinks, setOfferLinks] = useState<OfferLink[] | []>([])

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setOfferForm({
      ...offer,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitUpdateOffer({ title: offer.title, isVisible: offer.isVisible })
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Edit offer</strong>
      </CCardHeader>
      <CCardBody>
        {error.message.length > 0 && (
          <CAlert color="danger">Error: {error.message}</CAlert>
        )}
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                name="title"
                value={offer.title}
                onChange={handleChange}
                label="Name"
                minLength={3}
                maxLength={30}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormCheck
                name="isVisible"
                checked={offer.isVisible}
                onChange={handleChange}
                label="Active"
              />
            </CCol>
          </CRow>
          <CCol className="mb-3" sm={4}>
            <CButton
              className="me-3"
              onClick={() => {
                setOfferLinks((prev) => [...prev, initialOfferLink])
              }}
            >
              Added offer link
            </CButton>
            <CButton type="submit">Save</CButton>
          </CCol>
        </CForm>
        <div className="mb-3">
          <strong>Offer links</strong>
        </div>
        <Flex gap={40} wrap="wrap">
          <>
            {offer?.offerLink.map((item) => (
              <OfferLinkForm key={item.id} mode={'edit'} data={item} />
            ))}
            {offerLinks?.map((item, index) => (
              <OfferLinkForm key={index} mode={'create'} data={item} />
            ))}
          </>
        </Flex>
      </CCardBody>
    </CCard>
  )
}
